// src/pages/TermsConditionsPage.jsx
import React from "react";
import "../css/TermsConditionsPage.css";

const TermsConditionsPage = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-title">Terms & Conditions</h1>

      <p>
        Welcome to Metro Menswear (“we”, “us”, “our”). By accessing or using our
        website www.metromenswear.com, you agree to comply with and be bound by
        the following Terms & Conditions. If you do not agree with any part of
        these Terms, please discontinue using our website.
      </p>

      <h2>1. Company Introduction</h2>
      <p>
        The domain name www.metromenswear.com (“Website”) is operated by Metro
        Menswear, established under the laws of India, with its registered
        office at:
        <br />
        <strong>
          Nearby Chaudhri Charan Singh College, Umararkhera, Orai, District
          Jalaun, Uttar Pradesh – 285001.
        </strong>
      </p>

      <h2>2. Services</h2>
      <p>
        Metro Menswear is an online retailer offering apparel and lifestyle
        products across India. Visitors can browse, select, and purchase
        products directly through our website.
      </p>
      <p>
        Upon placing an order, we process, pack, and ship products through our
        partnered logistics providers. We are entitled to receive payment for
        such products as per pricing and terms displayed on the website.
      </p>

      <h2>3. Third-Party Websites and Content</h2>
      <p>
        Our website may provide links to third-party platforms such as Facebook,
        Instagram, or other external websites. These are provided for sharing or
        listing purposes only.
      </p>
      <p>
        Metro Menswear takes no responsibility for content available on such
        third-party websites and disclaims all liabilities arising from your
        interaction with them.
      </p>
      <p>
        We further disclaim responsibility for any comments, posts, or content
        shared by users on social media platforms, including content shared
        through links from our website or on official social media pages of
        Metro Menswear.
      </p>

      <h2>4. Use of Website</h2>
      <ul>
        <li>You must be at least 18 years old to use or purchase from our website.</li>
        <li>You agree not to misuse the website for illegal activities.</li>
        <li>We reserve the right to suspend access for misuse.</li>
      </ul>

      <h2>5. Products & Pricing</h2>
      <ul>
        <li>All products are subject to availability.</li>
        <li>Prices are in INR and include all applicable taxes unless mentioned.</li>
        <li>We may change prices, product descriptions, and availability anytime.</li>
      </ul>

      <h2>6. Orders & Payment</h2>
      <ul>
        <li>Orders are processed only after successful payment.</li>
        <li>We use secure third-party payment gateways.</li>
        <li>If payment is declined, the order will not be processed.</li>
        <li>
          We reserve the right to cancel orders due to system errors or suspected
          fraud.
        </li>
      </ul>

      <h2>7. Shipping & Delivery</h2>
      <ul>
        <li>Delivery times depend on your location and courier service.</li>
        <li>
          We are not responsible for delays caused by unforeseen circumstances
          (weather, strikes, logistics issues).
        </li>
        <li>
          Incorrect or incomplete addresses may lead to failed or delayed
          deliveries.
        </li>
      </ul>

      <h2>8. Return, Exchange & Refund Policy</h2>
      <ul>
        <li>
          Returns/exchanges are allowed only for manufacturing defects, wrong
          products, or size issues (if applicable).
        </li>
        <li>Products must be unused, unwashed, and in original packaging.</li>
        <li>
          Certain items (innerwear, accessories, discounted items) may not be
          eligible.
        </li>
        <li>Refunds are processed within 7–14 working days after approval.</li>
        <li>
          Refer to our Return & Refund Policy page for detailed information.
        </li>
      </ul>

      <h2>9. Cancellation Policy</h2>
      <ul>
        <li>Orders can be cancelled only before they are shipped.</li>
        <li>Once shipped, cancellation may not be possible.</li>
        <li>Refunds follow standard refund timelines.</li>
      </ul>

      <h2>10. Intellectual Property</h2>
      <ul>
        <li>
          All images, logos, designs, and content on this website belong to Metro
          Menswear.
        </li>
        <li>
          You may not copy, reproduce, or distribute content without written
          permission.
        </li>
      </ul>

      <h2>11. User Account</h2>
      <ul>
        <li>You are responsible for maintaining the confidentiality of your account.</li>
        <li>Any activity under your account will be your responsibility.</li>
      </ul>

      <h2>12. Limitation of Liability</h2>
      <p>
        Metro Menswear is not liable for any loss, damage, or injury arising from
        the use of our website or products. We do not guarantee error-free
        operation or uninterrupted access to the website.
      </p>

      <h2>13. Privacy Policy</h2>
      <p>
        We collect and store user data as per applicable laws. Personal data is
        not sold or shared except for necessary order processing. Please refer
        to our Privacy Policy page for more details.
      </p>

      <h2>14. Third-Party Links</h2>
      <p>
        Our website may contain third-party links. We are not responsible for
        their content, operations, privacy, or terms.
      </p>

      <h2>15. Governing Law & Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. All disputes fall under
        the jurisdiction of courts in Jalaun, Uttar Pradesh.
      </p>

      <h2>16. Changes to Terms</h2>
      <ul>
        <li>We may update these Terms without prior notice.</li>
        <li>Updates take effect once posted on the website.</li>
        <li>
          Continued use of the website means acceptance of updated Terms.
        </li>
      </ul>

      <h2>17. Contact Us</h2>
      <p><strong>Metro Menswear</strong></p>
      <p>
        Address: Nearby Chaudhri Charan Singh College, Umararkhera, Orai,
        District Jalaun, Uttar Pradesh – 285001
      </p>
      <p>Email: <a href="mailto:metromenswear01@gmail.com">metromenswear01@gmail.com</a></p>
      <p>Phone: <a href="tel:9486217297">94862 17297</a></p>

      <h2>Acceptance of Terms</h2>
      <p>
        By using this website, you acknowledge that you have read, understood,
        and agree to these Terms & Conditions.
      </p>
    </div>
  );
};

export default TermsConditionsPage;
